import { combineReducers } from "redux";
import { activeEventsOpen } from "./activeEventsOpen";
import { corgiModeEnabled, kittyModeEnabled } from "./corgiMode";
import { settings } from "./settings";
import { sourceType } from "./sourceType";
import { themeName } from "./themeName";
import { user } from "./user";

/** The combined session state, representing the current session information of the top frame. */
export const session = combineReducers({
  corgiModeEnabled,
  kittyModeEnabled,
  activeEventsOpen,
  settings,
  sourceType,
  themeName,
  user,
});
